export default __webpack_public_path__ + "static/media/2015.1e89ccea.png";